import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
// Shared components
import Paper from 'components/Paper';
import MaterialTableComponent from '../../../../../utils/MaterialTable'
import {getSpecialMethod} from '../../../../../services/specials/getSpecial'
import {jsonHighchart} from '../../../../../utils/HighchartJson/DualChart/highchartJson'
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import Loading from '../../../../../utils/Loading'
// Component styles
import styles from './styles';

import moment from 'moment'
import 'moment/locale/es'

//CAMBIA EL COLOR DE LA LEYENDA
(function(H) {
  H.wrap(H.Legend.prototype, 'colorizeItem', function(proceed, item, visible) {
      var color = item.color;

      item.color = item.options.legendColor;
      proceed.apply(this, Array.prototype.slice.call(arguments, 1));
      item.color = color;
  });
}(Highcharts));


class ComparativeSpecial extends Component {
  constructor(props) {
        
    super(props);
    this.state = {
      objective:this.props.dataSpecialObjective.objective,
      error:false,
      load:true,
      period: this.props.dataSpecialObjective.period,
      statePeriod:this.props.dataSpecialObjective.statePeriod,
      chartOptions: this.chartOptions,
    }
  }

  componentDidMount() {
    this.getDataFromAPI();
  }

  static getDerivedStateFromProps(props, state) {
    if(props.dataSpecialObjective.period!==state.period||props.dataSpecialObjective.statePeriod!==state.statePeriod){
      return{
        load:true,
        period:props.dataSpecialObjective.period,
        statePeriod:props.dataSpecialObjective.statePeriod,
      }
    }
    return null;
}
componentDidUpdate(prevProps, prevState) {
    if(prevState.period!== this.state.period||prevState.statePeriod!== this.state.statePeriod){
        this.getDataFromAPI();
    }
}

  getDataFromAPI=()=>{
    const {objective, period, statePeriod}=this.state
    const token = sessionStorage.getItem('key')
    const user = sessionStorage.getItem('user')
    const method=sessionStorage.getItem("methodSpecial")
    var begin=null
    var final=null
    if(period==="c"){
      begin=moment(statePeriod.startDate).format("YYYY-MM-DD")
      final=moment(statePeriod.endDate).add("days","1").format("YYYY-MM-DD")
    }
    const startDate = moment().subtract({"months":1}).startOf('month')
    let month = startDate.month() + 1
    let year = startDate.year()
    getSpecialMethod(objective,user, token, method, month, year, period, begin, final).then( value =>{
        try {
            this.processData(value)
                    
        } catch (error) {
            this.setState({
                error: true,
            });
        }
    })
  }

  processData=(data)=>{
    const {objective}=this.state
    var listGroupsWithChart=[]

    Promise.all(data).then(data2 =>{
      
      data2.map(ele=>{
        var listAvailability=[]
        var listResponse=[]
        var listNameObj=[]
        var dataEle=[]
        ele.lista_Objetivos.sort(function (a, b) {
          var availabilityA=a.disponibilidad.uptime+a.disponibilidad.parcial
          var availabilityB=b.disponibilidad.uptime+b.disponibilidad.parcial
          var order= availabilityB-availabilityA
          if(availabilityA===availabilityB){
            order=a.rendimiento - b.rendimiento
            
          }
          return order
        });

        var listColor=[]
        var markName=""
        ele.lista_Objetivos.map((obj, i)=>{
          var uptimeReal=obj.disponibilidad.uptime+obj.disponibilidad.parcial
          var color="#41B900"
          if(obj.objetivo_marcado===true){
            color="#00e676"
            markName=obj.nombreObjetivo
          }
          listColor.push(color)
          listAvailability.push(parseFloat((uptimeReal).toFixed(2)))
          dataEle.push({"disponibilidad":parseFloat((uptimeReal).toFixed(2)), "rendimiento":obj.rendimiento, "nombreObjetivo":obj.nombreObjetivo, "downtime":obj.disponibilidad.downtime})
          listResponse.push(obj.rendimiento)
          var nameObj=obj.nombreObjetivo
          if(obj!==""){
            nameObj=obj.nombreAliasObjetivo
            listNameObj.push(obj.nombreObjetivo)
          }
        })
        var jsonChart =jsonHighchart(listAvailability, listResponse, listNameObj, "", 'Uptime', 'Tiempo de Respuesta', '%', 's', listColor, markName)
        ele["keys"]=[{"title":'Bancos', 'field':'nombreObjetivo'},{"title":"Uptime",'field':'disponibilidad'},{"title":"Downtime",'field':"downtime"},{"title":"Tiempo de Respuesta",'field':"rendimiento"}]
        ele["dataMaterial"]=dataEle
        ele["chart"]=jsonChart
        listGroupsWithChart.push(ele)
      })
      this.setState({
        load: false,
        listGroupsWithChart:listGroupsWithChart,
      })
    })
  }
  
  render() {
    const { classes, className, ...rest } = this.props;
    const {load, listGroupsWithChart}=this.state
    
    if(load){
      return (
        <Grid
          container
          spacing={10}
        >
          <Loading />
        </Grid>
      );
    }else{
      return (
          listGroupsWithChart.map((ele, i)=>(
            <Grid
              container
              spacing={10}
              style={{paddingBottom:"75px"}}
            >
              <Grid
                key={ele.grupo}
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center"}}
              >
                <Typography style={{color:"rgb(102, 120, 138)"}} variant="h3">{ele.grupo}</Typography>
                <PerfectScrollbar>
                  <HighchartsReact
                      highcharts={Highcharts}
                      options={ele.chart} />
                </PerfectScrollbar>
              </Grid>
              <Grid
                key={ele.grupo}
                item
                xs={12}
                sm={12}
                md={5}
                xl={5}
                style={{textAlign:"left"}}
              >
                <Grid
                  container
                  spacing={3}
                >
                  <Grid
                    key={ele.grupo}
                    item
                    xs={3}
                    sm={3}
                    md={3}
                    xl={3}
                    style={{textAlign:"left"}}
                  >
                    <Typography style={{color:"rgb(102, 120, 138)"}} variant="h3">Downtime:</Typography>
                  </Grid>
                  <Grid
                    key={ele.grupo}
                    item
                    xs={9}
                    sm={9}
                    md={9}
                    xl={9}
                    style={{textAlign:"left"}}
                  >
                    <Typography style={{color:"rgb(102, 120, 138)", lineHeight:"35px"}} variant="h6">Todos los ISP's presentan caídas o errores de disponibilidad</Typography>
                  </Grid>
                  <Grid
                    key={ele.grupo}
                    item
                    xs={3}
                    sm={3}
                    md={3}
                    xl={3}
                    style={{textAlign:"left"}}
                  >
                    <Typography style={{color:"rgb(102, 120, 138)"}} variant="h3">ISP:</Typography>
                  </Grid>
                  <Grid
                    key={ele.grupo}
                    item
                    xs={9}
                    sm={9}
                    md={9}
                    xl={9}
                    style={{textAlign:"left", lineHeight:"35px"}}
                  >
                    {ele.listNodes.length>0?
                      ele.listNodes.map(dataNode=>(
                        <Typography style={{color:"rgb(102, 120, 138)", lineHeight:"35px"}} variant="h6">{dataNode.nombre}</Typography>
                      ))
                      :
                      <Typography style={{color:"rgb(102, 120, 138)", lineHeight:"35px"}} variant="h6">sin Isp</Typography>
                    }
                    
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                key={ele.grupo}
                item
                xs={12}
                sm={12}
                md={7}
                xl={7}
                style={{textAlign:"center"}}
              >
                <MaterialTableComponent keys={ele.keys} data={ele.dataMaterial} />
              </Grid>
            </Grid>
          ))
          
        
      );
    }
    
  }
}

ComparativeSpecial.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ComparativeSpecial);
